import { actionTypes, InitialState } from './context';

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_CHIME_DRAWER_STATUS:
      state.chimeSettings.drawerState = action.state;

      return;
    case actionTypes.SET_CHIME_DRAWER_STEP:
      state.chimeSettings.step = action.step;

      return;
    case actionTypes.SET_CHIME_DRAWER_IS_EDIT:
      state.chimeSettings.isEdit = action.isEdit;

      return;
    case actionTypes.SET_CHIME_DRAWER_ACTIVE_USER:
      state.chimeSettings.activeUser = action.user;

      return;
    case actionTypes.SET_CHIME_DRAWER_EDIT_MODE:
      state.chimeSettings.isEdit = true;
      state.chimeSettings.activeUser = action.user;
      state.chimeSettings.step = 2;
      state.chimeSettings.drawerState = true;

      return;
    case actionTypes.SET_CHIME_DRAWER_CREATE_MODE:
      state.chimeSettings.isEdit = false;
      state.chimeSettings.activeUser = action.user;
      state.chimeSettings.step = 1;
      state.chimeSettings.drawerState = true;

      return;
    default:
      return InitialState;
  }
};
